var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_30841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6855 0C7.39436 0 0.685547 6.70951 0.685547 15C0.685547 23.2912 7.39506 30 15.6855 30C23.9767 30 30.6855 23.2905 30.6855 15C30.6855 6.70881 23.976 0 15.6855 0ZM15.6855 28C8.51736 28 2.68553 22.1682 2.68553 15C2.68553 7.83176 8.51736 1.99998 15.6855 1.99998C22.8537 1.99998 28.6856 7.83182 28.6856 15C28.6856 22.1682 22.8537 28 15.6855 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6257 9.48821C23.2351 9.09768 22.6019 9.09768 22.2114 9.48821L13.3089 18.3908L9.15926 14.2412C8.76874 13.8507 8.13551 13.8507 7.74504 14.2412C7.35452 14.6317 7.35452 15.2649 7.74504 15.6554L12.6017 20.5121C12.9922 20.9026 13.6256 20.9024 14.0159 20.5121L23.6257 10.9024C24.0162 10.5118 24.0162 9.87874 23.6257 9.48821Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_30841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.685547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notification-success.fd29bd6cd5ae6ec1de40efd55dce6421.svg";
export { ForwardRef as ReactComponent };